import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

interface DraggableMenuState {
    showMenu: boolean
}


const initialState: DraggableMenuState = {
    showMenu: false
}

export const DraggableMenuSlice = createSlice({
    name: "DraggableMenu",
    initialState,
    reducers: {
        showMenu: (state, action: PayloadAction<boolean>) => {
            state.showMenu = action.payload;
        },
    }
});

export const DraggableMenuSelector = createSelector(
    (state: RootState) => state.draggableMenu,
    (data) => data
);

export const {
    showMenu,
} = DraggableMenuSlice.actions;

export default DraggableMenuSlice.reducer;